
const __sfc_main = {};
__sfc_main.props = {
  sale: {
    key: "sale",
    required: true,
    type: Object
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const saleLink = props.sale.type === 'installment' ? '/promo/66bdb898eae977320792762a/?utm_source=05ru&utm_medium=referrer&utm_campaign=bts&utm_content=banner-from-item-page&utm_term=rassroshka' : '/promo/66bdb898eae977320792762a/?utm_source=05ru&utm_medium=referrer&utm_campaign=bts&utm_content=banner-from-item-page&utm_term=vigodno';
  return {
    saleLink
  };
};
export default __sfc_main;
